import moment from 'moment';
import * as types from './../actionTypes';
import Resource from "../../services/Resource";
import analyticTypes from "../../components/analytics/analyticTypes";
import {hideSpinner, showSpinner} from "../spinnerActions";

export function loadAnalyticsSuccess(analytics) {
    return {type: types.LOAD_ANALYTICS_SUCCESS, analytics};
}
export function loadAllAnalyticsSuccess(allAnalytics) {
    return {type: types.LOAD_ALL_ANALYTICS_SUCCESS, allAnalytics};
}


export function loadMetricsSuccess(metrics) {
    return {type: types.LOAD_METRICS_SUCCESS, metrics};
}

export function loadDateRangeSuccess(context, minDate, maxDate) {
    return {type: types.LOAD_ANALYTICS_DATE_RANGE_SUCCESS, context, minDate, maxDate};
}

export function loadTotalSuccess(total) {
    return {type: types.LOAD_TOTAL_SUCCESS, total};
}

export function resetMetricsTable() {
    return {type: types.RESET_METRICS_TABLE};
}

/**
 * Load analytics from the server
 *
 * @param {string} context
 * @param {integer} startDate
 * @param {integer} endDate
 * @param {integer} companyId
 * @param {string} type
 * @param {string} groupBy
 * @param {string} dataType - type of loaded information (analytics or metrics)
 * @param {number} page
 * @param {number} onPage
 **/
export function loadAnalytics({context, startDate, endDate, companyId, groupBy, type = 'click', page, onPage}, dataType) {

    let params = {
        context,
        startDate,
        endDate,
        type,
        groupBy,
        companyId,
    };

    if(page !== undefined && onPage !== undefined) {
        params.page = page;
        params.onPage = onPage
    }

    return function (dispatch) {
        dispatch(showSpinner());
        return Resource.all('api/analytics/statistics', params).then(analytics => {
            switch (dataType) {
                case 'metrics':
                    dispatch(loadMetricsSuccess(analytics));
                    break;
                case 'total':
                    dispatch(loadTotalSuccess(analytics.total));
                    break;
                default:
                    dispatch(loadAnalyticsSuccess(analytics));
                    break;
            }
            dispatch(hideSpinner());
            return analytics;
        }).catch(error => {
            throw error;
        });
    }
}

export function loadDateRange(context, companyId) {
    return function (dispatch) {
        return Resource.options(`api/analytics/statistics/dates/${context}?companyId=${companyId}`).then(data => {
            dispatch(loadDateRangeSuccess(context, data.startDate, data.endDate));
        }).catch(error => {
            throw error;
        });
    }
}

/**
 * Load analytics from the server
 *
 * @param {integer} startDate
 * @param {integer} endDate
 * @param {integer} companyId
 * @param {string} type
 * @param {string} groupBy
 **/
export function loadAllAnalytics({startDate, endDate, companyId, groupBy, type = 'click'}) {
    return function (dispatch) {
        const contexts = Object.keys(analyticTypes).map(type => analyticTypes[type].context);
        const analyticPromises = [];

        contexts.forEach(context => {
            analyticPromises.push(Resource.all('api/analytics/statistics', {
                context,
                startDate,
                endDate,
                type,
                groupBy,
                companyId,
            }).then(analytics => {
                return {[context]: analytics};
            }));
        });

        return Promise.all(analyticPromises)
            .then(allAnalytics => {
                return dispatch(loadAllAnalyticsSuccess(Object.assign({}, ...allAnalytics)))
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/analytics/analyticsActions.js